import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ErrorView from '../views/ErrorView.vue'
import store from '@/store/index.js'
import { passlessLogin } from "@/api/user";
// import { Message } from 'element-ui';
import YJSProofOfReading from '@/views/View/YJSProofOfReading.vue'
import YJSJy from '@/views/View/YJSJy.vue'
import formindex from '@/views/Form/IndexView.vue'
import ValidForm from '@/views/Valid/ValidForm.vue'
import OldRascal from '@/views/OldRascal.vue'
import GuoHe from '@/views/View/GuoHe.vue'
import _this from '@/main'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta:{
      permission:'CustomizeAdmin',
    }
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView,
    meta:{
      permission:'CustomizeAdmin',
    }

  },
  {
    path: '/404',
    name: 'Error',
    component: ErrorView
  },
  {
    path: '/form',
    name: 'formindex',
    component: formindex,

  },
  {
    path:'/YJSProofOfReading',
    name:'YJSProofOfReading',
    component:YJSProofOfReading
  },
  {
    path:'/YJSJy',
    name:'YJSJy',
    component:YJSJy
  },
  {
    path:'/ValidForm',
    name:'ValidForm',
    component:ValidForm
  },
  {
    path:'/Admin',
    name:'Admin',
    component:OldRascal,
    meta:{
      permission:'CustomizeAdmin'
    }
  },
  {
    path:'/GuoHe',
    name:'GuoHe',
    component:GuoHe,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})



const loginasp = 'https://bddy.wmu.edu.cn/Bddy';
var path = '';
// eslint-disable-next-line no-unused-vars
const authorbyOther = function (_topath) {
  var loginServer = "https://authserver.wmu.edu.cn/authserver/login";
  path = loginasp;
  path += _topath;
  var url1 = loginServer + "?service=" + encodeURIComponent(path);
  window.location.href = url1;
}

const setUserinfo =async function(userid){
  await store.dispatch("user/setId", userid);
  await store.dispatch("user/getInfo");
  await store.dispatch("user/getOrgin");
}
// const allow = ['/begin','/']


const allow = ['/ValidForm','/GuoHe']
router.beforeEach(async (to, form, next) => {
  if (to.matched.length === 0) {  // 如果未匹配到路由
    form.name ? next({ name: form.name }) : next('/404');
  }
  else {
    console.log(store)
    if ((to.path!='/'&& allow.indexOf(to.path)>-1)||to.path == "/404") {
      next();
    }
    else if (store.getters.user.id) {
      // 说明已经登录过了
      console.log(to,'to')
      if(to.meta.permission){
        store.getters.user.auth[to.meta.permission]==true?next(): next('/404?msg=请先授权');      
      }
      else{
        next();
      }
    }
    else {
      try {
        /**这段是加上参数 */
        let addpath = [];
        if (to.query) {
          for (var i in to.query) {
            if (i != 'ticket') {
              addpath.push(`${i}=${to.query[i]}`);
            }
          }
        }

        let addpathstr = addpath.join('&');

        if(addpathstr.length>0){
          addpathstr = "?" + addpathstr;
        }
        if(to.path!="/"){
          addpathstr = to.path + addpathstr
        }

        let querypath = 'https://bddy.wmu.edu.cn/Bddy' + addpathstr;

        /**获取当前用户是否已经登录 */
        const abpConfig = await store.dispatch(
          "app/applicationConfiguration"
        );
        if (process.env.NODE_ENV === "development") { 
          if(abpConfig.currentUser && abpConfig.currentUser.id){
            // 如果测试版本
            await setUserinfo(abpConfig.currentUser.id);
            await store.dispatch("user/setAuth",abpConfig.auth.grantedPolicies);
            console.log(2,to);
            if(to.meta.permission){
              
              store.getters.user.auth[to.meta.permission]==true?next(): next('/404?msg=请先授权');      
            }
            else{
              next();
            }
          }
          else{
            next({
              path: `/404`,
              query:{
                msg:'请先登录'
              }
            });  
          }

          // await this.dateChange();
        }
        else if (to.query && to.query.ticket) {
            //有ticket；
            const ticket = to.query.ticket;
            const res = await passlessLogin({
              ticket: ticket,
              url: querypath,
            });
            if (res) {
              if (res.state == 1) {
                const abpConfig = await store.dispatch(
                  "app/applicationConfiguration"
                );

                await setUserinfo(abpConfig.currentUser.id);
                await store.dispatch("user/setAuth",abpConfig.auth.grantedPolicies);
                if(to.meta.permission){
                  store.getters.user.auth[to.meta.permission]==true?next(): next('/404?msg=请先授权');       
                }
                else{
                  next();
                }
              }
              else if (res.state == 2) {
                // Message({
                //   showClose: true,
                //   message: '这是一条消息提示',
                //   type: 'error'
                // });
              }
              else if (res.state == 3){
                _this.$vs.notification({
                  color:'danger',
                  position:'top-center',
                  title:'错误信息',
                  text:'当前用户已被锁定',
                  icon:"<i class='bx bx-error' ></i>",
                  onDestroy:()=>{
                    store.dispatch('user/resetToken').then(() => {
                      location.reload()
                    })
                  }
                });
                next('/404?msg='+'当前用户已被锁定');
              }
              else {
                authorbyOther(addpathstr)
              }
            }
        }
        else {
          authorbyOther(addpathstr)
        }
      }
      catch (error) {
        console.log(error);
      }
      finally {
        console.log(123);
      }
    }
  }
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}



export default router
